import React from 'react';

const PlayIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="g1" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#00C6FF"/><stop offset="100%" stopColor="#0068B3"/></linearGradient>
      <linearGradient id="g2" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#00E676"/><stop offset="100%" stopColor="#00897B"/></linearGradient>
      <linearGradient id="g3" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#FF6D00"/><stop offset="100%" stopColor="#FF3D00"/></linearGradient>
      <linearGradient id="g4" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#FFD600"/><stop offset="100%" stopColor="#FF6D00"/></linearGradient>
    </defs>
    <path d="M4 2.5L18.5 16 4 29.5V2.5Z" fill="url(#g1)"/>
    <path d="M4 2.5L22 11.5L18.5 16L4 2.5Z" fill="url(#g2)"/>
    <path d="M4 29.5L22 20.5L18.5 16L4 29.5Z" fill="url(#g3)"/>
    <path d="M22 11.5L28 15C29.1 15.6 29.1 16.4 28 17L22 20.5L18.5 16L22 11.5Z" fill="url(#g4)"/>
  </svg>
);

export default PlayIcon;
